
import util from '../util/Util';
import {getProviderTypes} from '../util/Enum';
import MoonLoader from 'vue-spinner/src/MoonLoader.vue'
import Person from './svgs/Person.vue';
const StarRating  = () => import('vue-star-rating');

export default {
  name: 'Carousel',
  components: {
    MoonLoader,
    Person,
    StarRating
  },
  props: {
    userId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      profile:{},
      isLoading: true,
      getProviderTypes,
      util,
      
    };
  },
  mounted() {
    this.$store.dispatch('user/getProfileDetailsById', this.userId).then((res) => {
      if(res.isSuccess) {
        this.profile = res.result
        this.isLoading = false
      } else {
        this.$toast.error('Failed to Get Profile Details - Contact support@utransport.com.au').goAway(5000)
        this.isLoading = false
        }
      })
    
  }
};
